import { GenerateCommentAttachmentUploadUrlRequestDtoContentType } from "@/spz-api/model/generateCommentAttachmentUploadUrlRequestDtoContentType";
import { useState } from "react";
import { useUploadCommentAttachmentMutation } from "./mutations/use-upload-comment-attachment.mutation";

const allowedFileTypes = Object.values(
  GenerateCommentAttachmentUploadUrlRequestDtoContentType,
);

export const useControlResultActivityAttachmentForm = ({
  controlId,
  controlResultId,
}: { controlId: string; controlResultId: string }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const uploadCommentAttachmentMutation = useUploadCommentAttachmentMutation({
    controlId,
    controlResultId,
  });

  return {
    allowedFileTypes,
    value: selectedFile,
    valid: !!selectedFile,
    update: (file: File | null) => {
      setSelectedFile(file);
    },
    reset: () => {
      setSelectedFile(null);
    },
    submit: uploadCommentAttachmentMutation.mutateAsync,
    submitting: uploadCommentAttachmentMutation.isPending,
  };
};
